(() => {
  if (window.vehicleFitmentIndexReady) {
    return;
  }

  const readyEvent = "vehicle-fitment-index:ready";
  const errorEvent = "vehicle-fitment-index:error";
  const config = window.vehicleFitmentIndexConfig || {};
  const proxyUrl = new URL(config.proxyUrl || "/apps/fitment-index", window.location.origin);
  const language = config.locale || document.documentElement.lang || "en";
  proxyUrl.searchParams.set("locale", /^es(?:-[a-z0-9]+)*$/i.test(language) ? "es" : "en");
  const fallback = Array.isArray(window.vehicleFitmentInlineFallback)
    ? window.vehicleFitmentInlineFallback
    : Array.isArray(window.vehicleFitmentIndex)
      ? window.vehicleFitmentIndex
      : [];

  window.vehicleFitmentIndex = fallback;
  window.vehicleFitmentIndexStatus = {
    loading: true,
    complete: false,
    source: fallback.length ? "liquid-fallback" : "empty",
    error: null,
  };

  const dispatch = (name, detail) => {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  };

  const hiddenMakeTokens = () => {
    const hidden = window.hiddenVehicleMakes || {};
    return {
      ids: new Set((Array.isArray(hidden.ids) ? hidden.ids : []).map((value) => String(value))),
      gids: new Set((Array.isArray(hidden.gids) ? hidden.gids : []).map((value) => String(value))),
    };
  };

  const filterDiscoveryFitments = (fitments) => {
    const hidden = hiddenMakeTokens();

    return fitments.filter((fitment) => {
      const makeId = fitment?.make?.id ? String(fitment.make.id) : "";
      const makeGid = fitment?.make?.gid ? String(fitment.make.gid) : "";

      return !hidden.ids.has(makeId) && !hidden.gids.has(makeGid);
    });
  };

  window.vehicleFitmentDiscoveryIndex = filterDiscoveryFitments(window.vehicleFitmentIndex);

  window.vehicleFitmentIndexReady = fetch(proxyUrl, {
    cache: "no-cache",
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Fitment index request failed with ${response.status}`);
      }

      return response.json();
    })
    .then((payload) => {
      if (!Array.isArray(payload?.fitments)) {
        throw new Error("Fitment index response did not include a fitments array.");
      }

      window.vehicleFitmentIndex = payload.fitments;
      window.vehicleFitmentDiscoveryIndex = filterDiscoveryFitments(payload.fitments);
      window.vehicleFitmentIndexPayload = payload;
      window.vehicleFitmentIndexStatus = {
        loading: false,
        complete: true,
        source: payload.source || "app-proxy",
        generatedAt: payload.generatedAt || null,
        error: null,
      };
      dispatch(readyEvent, window.vehicleFitmentIndexStatus);
      return window.vehicleFitmentIndex;
    })
    .catch((error) => {
      window.vehicleFitmentIndexStatus = {
        loading: false,
        complete: false,
        source: fallback.length ? "liquid-fallback" : "empty",
        error: error.message,
      };
      window.vehicleFitmentDiscoveryIndex = filterDiscoveryFitments(window.vehicleFitmentIndex);
      dispatch(errorEvent, window.vehicleFitmentIndexStatus);
      dispatch(readyEvent, window.vehicleFitmentIndexStatus);
      return window.vehicleFitmentIndex;
    });
})();
